// Hospitality images
import imgTwoVillasHoliday from '@/assets/img/our-brands/hospitality/two-villas-holiday/two_villas_holiday.jpg'
import imgSaturdaysResidence from '@/assets/img/our-brands/hospitality/saturdays-residence/saturdays_residence.jpg'
import imgOnyxPoolVilla from '@/assets/img/our-brands/hospitality/onyx-pool-villa/onyx_pool_villa.jpg'
import imgWingsPhuketVilla from '@/assets/img/our-brands/hospitality/wings-phuket-villa/wings_phuket_villa.jpg'
import imgOxygenPoolVilla from '@/assets/img/our-brands/hospitality/oxygen-pool-villa/oxygen_pool_villa.jpg'
import imgBluMonkeyPhuketTown from '@/assets/img/our-brands/hospitality/blu-monkey-phuket-town/blu_monkey_phuket_town.jpg'
import imgBluMonkeyNaiharnBeach from '@/assets/img/our-brands/hospitality/blu-monkey-naiharn-beach/blu_monkey_naiharn_beach.jpg'

// Real Estate images
import imgTheAttitudeClub from '@/assets/img/our-brands/real-estate/the-attitude-club/attitude_club.jpg'
import imgMonoPhuket from '@/assets/img/our-brands/real-estate/mono-phuket/mono_phuket.jpg'
import imgNumberTwelve from '@/assets/img/our-brands/real-estate/number-twelve/number_twelve.jpg'

// Food & Beverage images
import imgOrigamiNeighborhood from '@/assets/img/our-brands/food-and-beverage/origami-neigborhood/origami_neigborhood_cafe.jpg'
import imgOrigamiSaturdays from '@/assets/img/our-brands/food-and-beverage/origami-saturdays/origami_saturdays.jpg'
import imgOrigamiWings from '@/assets/img/our-brands/food-and-beverage/origami-wings/origami_wings.jpg'
import imgOrigamiBangtao from '@/assets/img/our-brands/food-and-beverage/origami-bangtao/origami_bangtao.jpg'

export const HOSPITALITY_LIST = [
  {
    title: 'Two Villas Holiday',
    subtitle: 'Your Home away from Home',
    description: 'Two Villas Holiday serves as the flagship brand of the Brown Starling Group\'s portfolio, embodying a sense of warmth and the comfort of a second home in Phuket. Each property within the Two Villas Holiday brand features a private pool villa, offering guests a unique and tranquil getaway.',
    link: 'https://www.brownstarling.com/pool-villa.html',
    imageList: [
      imgTwoVillasHoliday
    ]
  },
  {
    title: 'Saturdays Residence',
    subtitle: 'Inspire your long stay holiday',
    description: 'Experience a classic New York bay apartment-style residence at Saiyuan on Phuket\'s south coast, just minutes away from Naiharn Beach. Stay at Saturdays Residence and embrace a lifestyle of modern comfort and convenience that is designed to enhance your extended holiday.',
    link: 'https://www.saturdaysresidence.com/',
    imageList: [
      imgSaturdaysResidence
    ]
  },
  {
    title: 'Onyx Pool Villa',
    subtitle: 'Ideal for couples or a family vacation',
    description: 'The elegantly designed two-bedroom Onyx villas exude luxury, offering a contemporary-rustic atmosphere perfect for romance. These private pool villas are conveniently situated for easy access to Naiharn Beach and are not far from Phuket Town.',
    link: 'https://www.brownstarling.com/onyx.html',
    imageList: [
      imgOnyxPoolVilla
    ]
  },
  {
    title: 'Wings Phuket Villa',
    subtitle: 'Experience the perfect blend of comfort & elegance',
    description: 'Discover the allure of a beautifully designed pool villa that showcases a captivating fusion of modern Sino summertime aesthetics and authentic rustic charm. The Peranakan-style architecture adds a unique touch, making it an ideal retreat for couples or family getaways.',
    link: 'https://www.brownstarling.com/wing.html',
    imageList: [
      imgWingsPhuketVilla
    ]
  },
  {
    title: 'Oxygen Pool Villa',
    subtitle: 'Together good vibes',
    description: 'Experience a stylish stay in Phuket by relaxing in an Oxygen Style duplex that features a private pool and garden, conveniently located near Bangtao Beach.',
    link: 'https://www.brownstarling.com/oxygen.html',
    imageList: [
      imgOxygenPoolVilla
    ]
  },
  {
    title: 'Blu Monkey Phuket Town',
    subtitle: 'Crafted with passion',
    description: 'A hotel that embodies heart and creativity, where love for pottery art and greenery converge in the Simply Phuket concept. This unique accommodation offers standard hotel comforts like quality beds and amenities while providing a warm, friendly atmosphere infused with local charm.',
    link: 'https://www.facebook.com/blumonkeyboutiquephukettown/',
    imageList: [
      imgBluMonkeyPhuketTown
    ]
  },
  {
    title: 'Blu Monkey Naiharn Beach',
    subtitle: 'Style and Relaxation',
    description: 'Blu Monkey Boutique Naiharn Beach is a chic and recently opened hotel located in close proximity to Nai Harn Beach in Phuket, Thailand. The hotel features uniquely designed one-bedroom and two-bedroom suites, each equipped with a pantry area that provides the comfort and convenience necessary for an extended holiday.',
    link: 'https://www.facebook.com/blumonkeyboutiquenaiharn/',
    imageList: [
      imgBluMonkeyNaiharnBeach
    ]
  }
]

export const REAL_ESTATE_LIST = [
  {
    title: 'The Attitude Club',
    subtitle: '',
    description: 'The Attitude Club offers a range of creatively conceived contemporary properties area, management services and lifestyle options for people seeking the perfect property as a permanet, temporary or holiday home.',
    link: 'https://theattitudeclub.com/',
    imageList: [
      imgTheAttitudeClub
    ]
  },
  {
    title: 'Mono Phuket',
    subtitle: '',
    description: 'The pool villa, designed in Asian Fusion Style, draws inspiration from the unique charm and aesthetic of Asia, seamlessly blending the art of living with a profound appreciation for nature. Mono projects are strategically located in various prime areas throughout Phuket.',
    link: 'https://www.monophuket.com/',
    imageList: [
      imgMonoPhuket
    ]
  },
  {
    title: 'Number Twelve',
    subtitle: '',
    description: 'One Stop Stylish Number 12 company speciallizes in high-end interior design for luxury property in Phuket. Highly cherished Asian furniture and decorative object for sales. And provide interior design services to a discerning clientele.',
    link: 'https://www.facebook.com/No.12companylimited/',
    imageList: [
      imgNumberTwelve
    ]
  }
]

export const FOOD_AND_BEVERAGE_LIST = [
  {
    title: 'Origami Neigborhood',
    subtitle: '',
    description: 'A café designed in a contemporary vintage style, blending the charm of French café culture with the unique Peranakan heritage. This branch is located in the hearth of Phuket town.',
    link: 'https://www.facebook.com/neighborgoodcafe/',
    imageList: [
      imgOrigamiNeighborhood
    ]
  },
  {
    title: 'Origami Saturdays',
    subtitle: '',
    description: 'Origami café Saturdays branch is located within Saturdays Residence project in Naiharn Beach. It offers both a cozy, friendly zone for a relaxed atmosphere and an area overlooking the swimming pool.',
    link: 'https://www.facebook.com/profile.php?id=61580295055313#',
    imageList: [
      imgOrigamiSaturdays
    ]
  },
  {
    title: 'Origami Wings',
    subtitle: '',
    description: 'Origami Wings branch is located within the Wings Villa project in Pasak and features a modern design that combines bright white spaces for a fresh, lively feel with warm grey tones that create a cozy atmosphere.',
    link: 'https://www.facebook.com/p/Origami-Cafe-Wings-Villa-100063914570360/',
    imageList: [
      imgOrigamiWings
    ]
  },
  {
    title: 'Origami Bangtao',
    subtitle: '',
    description: 'Origami Café Bangtao branch is designed in a warm and bright Scandinavian style, emphasizing natural light and a cozy atmosphere. It\'s located just 5 minutes from Bangtao beach.',
    link: 'https://www.facebook.com/origamicafebangtaophuket',
    imageList: [
      imgOrigamiBangtao
    ]
  }
]
